/**
 * @file Newsletter Banner.
 */

/**
 * Newsletter banner.
 */
const vNewsletterBanner = () => {
	const newsletter = document.querySelector('.v-newsletter-banner');
	if (!newsletter) return;
	const response = newsletter.querySelector('.v-newsletter-banner__response');
	const message = newsletter.querySelector('.v-newsletter-banner__response-text');

	document.addEventListener('wpcf7mailsent', (e) => {
		if (e.detail.contactFormId !== '789') return;
		message.innerHTML = 'Thank you for signing up for news & updates.';
		response.classList.add('open');
	}, false);

	document.addEventListener('wpcf7invalid', (e) => {
		if (e.detail.contactFormId !== '789') return;
		message.innerHTML = 'An email address is required in order to sign up.';
		response.classList.add('open');
	}, false);

	document.addEventListener('wpcf7spam', (e) => {
		if (e.detail.contactFormId !== '789') return;
		message.innerHTML = 'Sorry, something went wrong. Please try again later.';
		response.classList.add('open');
	}, false);

	document.addEventListener('wpcf7mailfailed', (e) => {
		if (e.detail.contactFormId !== '789') return;
		message.innerHTML = 'Sorry, something went wrong. Please try again later.';
		response.classList.add('open');
	}, false);
};

export default vNewsletterBanner;
